import { EEGPage } from "./EEGPage";
import { getDataReviewPageRequestConcurrency } from "./DataReviewExperiment";
import { TimeSeriesPageQueue } from "./TimeSeriesDataQueue";
import { TimeSeriesPageManager } from "./TimeSeriesPageManager";

export class EEGTimeSeriesPageManager extends TimeSeriesPageManager<EEGPage> {
	protected pageQueue = new TimeSeriesPageQueue<EEGPage>(getDataReviewPageRequestConcurrency())

	getPageMaker(): () => EEGPage {
		return (): EEGPage => new EEGPage(this)
	}

	protected getNumberOfCachedPages(): number {
		return 256
	}
}
